import {
  checkEventDashboardPageOriginResponse,
  eventDashboardPageOriginHeaders,
} from './eventDashboardPageOrigin';
import { RELEASE_ID, RELEASE_REQUEST_HEADER } from './identity';

export const reloadNavigator = {
  reload: () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  },
};

export async function releaseFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const requestInput = typeof Request !== 'undefined' && input instanceof Request ? input : undefined;
  const headers = eventDashboardPageOriginHeaders(input, init.headers || requestInput?.headers);
  headers.set(RELEASE_REQUEST_HEADER, RELEASE_ID);

  const response = await fetch(input, { ...init, headers });
  checkEventDashboardPageOriginResponse(response);
  return response;
}
